<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M17.0711 4.69671L15.3033 2.92894L10 8.23224L4.6967 2.92894L2.92893 4.69671L8.23223 10L2.92893 15.3033L4.6967 17.0711L10 11.7678L15.3033 17.0711L17.0711 15.3033L11.7678 10L17.0711 4.69671Z" />
</svg>
